import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import FCoverImage from '@/components/FCoverImage';
import FResourceStatusBadge from '@/components/FResourceStatusBadge';
import { connect } from 'dva';
import { ConnectState, ResourceCreatorBatchPageState } from '@/models/connect';
import { Dispatch } from 'redux';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FTooltip from '@/components/FTooltip';
import fSignResourceToNode from '@/components/fSignResourceToNode';
import { history } from 'umi';
import fCenterMessage from '@/components/fCenterMessage';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import fCollectionSelector from '@/components/fCollectionSelector';
import FDrawer from '@/components/FDrawer';
import FCheckbox from '@/components/FCheckbox';
import * as AHooks from 'ahooks';
import moment from 'moment';
import FAddResourcesHandleAuth from '@/components/FAddResourcesHandleAuth';
import FIcons from '@/components/FIcons';

interface FinishProps {
  dispatch: Dispatch;
  resourceCreatorBatchPage: ResourceCreatorBatchPageState;
}

function Finish({ dispatch, resourceCreatorBatchPage }: FinishProps) {

  const [$addItemsDrawerOpen, set$addItemsDrawerOpen, get$addItemsDrawerOpen] = FUtil.Hook.useGetState<boolean>(false);
  const [$checkedResourceIDs, set$checkedResourceIDs, get$checkedResourceIDs] = FUtil.Hook.useGetState<string[]>([]);
  const [$collectionID, set$collectionID, get$collectionID] = FUtil.Hook.useGetState<string>('');

  return (<div className={styles.container4}>
    <div style={{ height: 60 }} />
    <div style={{
      fontSize: 30,
      fontWeight: 400,
      color: '#666',
      lineHeight: '42px',
    }}>{FI18n.i18nNext.t('brr_completed_msg')}
    </div>
    <div style={{ height: 30 }} />
    <div style={{
      fontSize: 16,
      fontWeight: 400,
      color: '#666',
      lineHeight: '22px',
    }}>{FI18n.i18nNext.t('brr_completed_msg2')}
    </div>
    <div style={{ height: 60 }} />
    <Space size={60}>
      <FHotspotTooltip
        id={'result.createResourceSuccess.manageMyResourceButton'}
        style={{ right: 16, bottom: -40 }}
        text={FI18n.i18nNext.t('hotpots_rqr_viewresource')}
        onOpenChange={(o) => {
          if (o) {
            fSetHotspotTooltipVisible('result.createResourceSuccess.manageMyResourceButton', {
              value: false,
              effectiveImmediately: false,
              onlyNullish: false,
            });
          }
        }}
      >
        <FComponentsLib.FTextBtn
          type={'primary'}
          onClick={() => {
            fSetHotspotTooltipVisible('result.createResourceSuccess.manageMyResourceButton', {
              value: false,
              effectiveImmediately: true,
              onlyNullish: false,
            });
            self.open(FUtil.LinkTo.myResources());
          }}
          style={{ display: 'flex', alignItems: 'center', gap: 5 }}
        >
          <FIcons.FSetting style={{ fontSize: 14 }} />
          <span>{FI18n.i18nNext.t('brr_completed_btn_viewmyresource')}</span>
        </FComponentsLib.FTextBtn>
      </FHotspotTooltip>
      <FComponentsLib.FTextBtn
        type={'primary'}
        onClick={() => {
          self.open(FUtil.LinkTo.resourceCreatorEntry());
        }}
        style={{ display: 'flex', alignItems: 'center', gap: 5 }}
      >
        <FIcons.FAdd style={{ fontSize: 14 }} />
        <span>{FI18n.i18nNext.t('brr_completed_btn_moretorelease_single')}</span>
      </FComponentsLib.FTextBtn>

      <FComponentsLib.FTextBtn
        type={'primary'}
        onClick={async () => {
          const resourceIDs: string[] = resourceCreatorBatchPage.resultList
            .filter((r) => {
              return r.status === 'online';
            })
            .map((r) => {
              return r.resourceID;
            });
          if (resourceIDs.length === 0) {
            fCenterMessage({ message: '不存在上线资源不能签约到节点' });
            return;
          }
          const result = await fSignResourceToNode({
            resourceIDs: resourceIDs,
          });
          if (result) {
            if (result.allIsTheme) {
              history.push(FUtil.LinkTo.nodeManagement({ nodeID: result.nodeID, showPage: 'theme' }));
            } else {
              history.push(FUtil.LinkTo.nodeManagement({ nodeID: result.nodeID }));
            }
          }
        }}
        style={{ display: 'flex', alignItems: 'center', gap: 5 }}
      >
        <FIcons.FNodes style={{ fontSize: 14, color: 'inherit' }} />
        <span>{FI18n.i18nNext.t('myresources_bulkaction_btn_addtomynode')}</span>
      </FComponentsLib.FTextBtn>

      <FComponentsLib.FTextBtn
        type={'primary'}
        onClick={async () => {
          set$addItemsDrawerOpen(true);
        }}
        style={{ display: 'flex', alignItems: 'center', gap: 5 }}
        disabled={!resourceCreatorBatchPage.resultList.some((r) => {
          return r.status === 'online';
        })}
      >
        <FIcons.FResource style={{ fontSize: 14, color: 'inherit' }} />
        <span>添加至合集</span>
      </FComponentsLib.FTextBtn>
    </Space>
    <div style={{ height: 50 }} />
    <div className={styles.list}>
      {
        resourceCreatorBatchPage.resultList.map((result) => {
          return (<div
            className={[styles.card, result.failReason !== '' ? styles.error : ''].join(' ')}
            key={result.resourceID}
          >
            <div className={styles.cardLeft}>
              <div style={{ position: 'relative' }}>
                <FCoverImage
                  src={result.cover}
                  width={112}
                  // style={{ display: 'block' }}
                />
                <div style={{ position: 'absolute', top: 5, left: 5 }}>
                  <FResourceStatusBadge
                    status={result.status}
                  />
                </div>
              </div>
              <div>
                <FComponentsLib.FContentText
                  text={result.resourceTitle}
                  type={'highlight'}
                  singleRow
                  style={{ maxWidth: 400 }}
                />
                <div style={{ height: 10 }} />
                <FComponentsLib.FContentText
                  text={result.resourceName}
                  type={'additional2'}
                  singleRow
                  style={{ maxWidth: 400 }}
                />
                <div style={{ height: 10 }} />
                <div className={styles.MetaFooter}>
                  {
                    result.policies.length > 0
                      ? (<FComponentsLib.F_Contract_And_Policy_Labels
                        data={result.policies.map((p) => {
                          return {
                            text: p,
                            dot: '',
                          };
                        })}
                        singleRow
                      />)
                      : (<FComponentsLib.FContentText
                        text={FI18n.i18nNext.t('brr_completed_item_msg_noauthplan')}
                        type='additional2'
                      />)
                  }
                </div>
              </div>
            </div>
            <div className={styles.cardRight}>
              {
                result.failReason !== ''
                  ? (<Space size={5}>
                      <span style={{ color: '#EE4040' }}>{FI18n.i18nNext.t('brr_completed_item_error')}</span>
                      <FTooltip title={result.failReason}>
                        <FIcons.FInfo style={{ color: '#EE4040', fontSize: 16 }} />
                      </FTooltip>
                    </Space>
                  )
                  : (<FComponentsLib.FTextBtn
                    type={'primary'}
                    onClick={() => {
                      self.open(FUtil.LinkTo.resourceDetails({
                        resourceID: result.resourceID,
                      }));
                    }}
                  >{FI18n.i18nNext.t('brr_completed_item_btn_viewdetails')}</FComponentsLib.FTextBtn>)
              }

            </div>
          </div>);
        })
      }
    </div>

    <div style={{ height: 100 }} />

    <SelectResourceDrawer
      open={$addItemsDrawerOpen}
      // resourceIDs={['672c6598dd9fe600301fafe0', '672c6598dd9fe600301faff1']}
      resourceIDs={resourceCreatorBatchPage.resultList
        .filter((rl) => {
          return rl.status === 'online';
        })
        .map((rl) => {
          return rl.resourceID;
        })}
      onConfirm={async (resourceIDs) => {
        set$checkedResourceIDs(resourceIDs);
        set$addItemsDrawerOpen(false);
        const collectionID = await fCollectionSelector();
        if (!collectionID) {
          return;
        }
        set$collectionID(collectionID);

        // const { ret, errCode, msg, data } = await FServiceAPI.Resource.addResourceItems_Draft({
        //   resourceId: collectionID,
        //   addCollectionItems: resource.map((r) => {
        //     return {
        //       resourceId: r.resourceID,
        //       itemTitle: r.resourceTitle,
        //     };
        //   }),
        //   isPublish: 1,
        // });
      }}
      onClose={() => {
        set$addItemsDrawerOpen(false);
      }}
    />

    <FAddResourcesHandleAuth
      collectionID={$collectionID}
      resourceIDs={$checkedResourceIDs}
      onBack={async () => {
        set$collectionID('');
        const collectionID = await fCollectionSelector();
        if (!collectionID) {
          return;
        }
        set$collectionID(collectionID);

      }}
      onOk={() => {
        set$collectionID('');
      }}
      onCancel={async () => {
        set$collectionID('');
      }}
      onError={() => {
        set$collectionID('');
      }}
    />
  </div>);
}

export default connect(({ resourceCreatorBatchPage }: ConnectState) => ({
  resourceCreatorBatchPage: resourceCreatorBatchPage,
}))(Finish);

interface SelectResourceDrawerProps {
  open: boolean;
  resourceIDs: string[];

  onConfirm?(resourceIDs: string[]): void;

  onClose?(): void;
}

export function SelectResourceDrawer({ open, resourceIDs, onConfirm, onClose }: SelectResourceDrawerProps) {

  const [$resourceList, set$resourceList, get$resourceList] = FUtil.Hook.useGetState<{
    id: string;
    cover: string;
    name: string;
    title: string;
    type: string[];
    status: 'freeze' | 'online' | 'unreleased' | 'offline';
    updateDate: string;
    baseUpcast: any[];
  }[]>([]);

  const [$checkedResourceIDs, set$checkedResourceIDs, get$checkedResourceIDs] = FUtil.Hook.useGetState<string[]>([]);

  AHooks.useMount(async () => {
    if (resourceIDs.length === 0) {
      return;
    }
    const { data }: {
      data: any[];
    } = await FServiceAPI.Resource.batchInfo({
      resourceIds: resourceIDs.join(','),
    });
    // console.table(data);
    set$resourceList(data.map((c) => {
      return {
        id: c.resourceId,
        cover: c.coverImages[0] || '',
        name: c.resourceName,
        title: c.resourceTitle,
        type: c.resourceType,
        status: c.status === 2
          ? 'freeze'
          : c.status === 1
            ? 'online'
            : c.status === 0
              ? 'unreleased'
              : 'offline',
        updateDate: moment(c.updateDate).format('YYYY-MM-DD'),
        // collectionStatus: c.serializeStatus === 1 ? 'finish' : 'unFinish',
        baseUpcast: c.baseUpcastResources,
      };
    }));
    set$checkedResourceIDs(data.map((c) => {
      return c.resourceId;
    }));
  });

  return (<FDrawer
    open={open}
    // open={true}
    width={700}
    // title={'选择资源'}
    title={FI18n.i18nNext.t('addtomycollection_title_selectresources')}

    topRight={<Space size={30}>
      <FComponentsLib.FTextBtn
        type='default'
        onClick={() => {
          onClose?.();
        }}
      >取消</FComponentsLib.FTextBtn>

      <FComponentsLib.FRectBtn
        type='primary'
        disabled={$checkedResourceIDs.length === 0}
        // onClick={onConfirm_VersionsDrawer}
        onClick={() => {
          onConfirm?.(get$checkedResourceIDs());
          // onConfirm?.(get$checkedResourceIDs().map((id) => {
          //   const resource = get$resourceList().find((r) => {
          //     return r.id === id;
          //   });
          //   return {
          //     resourceID: id,
          //     resourceTitle: resource?.title || '',
          //     baseUpcastResources: resource?.baseUpcast || [],
          //   };
          // }));
          // set$open(false);
        }}
      >
        {/*加入合集*/}
        {FI18n.i18nNext.t('addtomycollection_btn_continue')}
      </FComponentsLib.FRectBtn>
    </Space>}
  >

    <FComponentsLib.FContentText type={'additional2'} text={'addtomycollection_selectresources_info'} />
    <div style={{ height: 30 }} />
    <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
      <FCheckbox
        checked={$checkedResourceIDs.length === $resourceList.length}
        indeterminate={$checkedResourceIDs.length > 0 && $checkedResourceIDs.length < $resourceList.length}
        onChange={(e) => {
          if (e.target.checked) {
            set$checkedResourceIDs(get$resourceList().map((c) => {
              return c.id;
            }));
          } else {
            set$checkedResourceIDs([]);
          }
        }}
      />

      {/*<span>全选</span>*/}
      <span>{FI18n.i18nNext.t('addtomycollection_selectresources_checkbox_selectall')}</span>
    </div>
    <div style={{ height: 20 }} />
    <div className={styles.resources}>
      {
        $resourceList
          .map((rl) => {
            return (<div
              key={rl.id}
              className={styles.resource}
              onClick={() => {
                if (get$checkedResourceIDs().includes(rl.id)) {
                  set$checkedResourceIDs(get$checkedResourceIDs().filter((id) => {
                    return id !== rl.id;
                  }));
                } else {
                  set$checkedResourceIDs([
                    ...get$checkedResourceIDs(),
                    rl.id,
                  ]);
                }
              }}
            >
              <FCheckbox
                checked={$checkedResourceIDs.includes(rl.id)}
              />
              <div className={styles.card}>
                <div className={styles.cover}>
                  <FCoverImage
                    src={rl.cover}
                    width={64}
                    style={{ borderRadius: 4 }}
                  />
                  <FResourceStatusBadge
                    status={rl.status}
                    style={{ position: 'absolute', top: 5, left: 5 }}
                  />
                </div>

                <div className={styles.content}>
                  <FComponentsLib.FContentText
                    text={rl.title}
                    type={'highlight'}
                  />
                  <div style={{ height: 10 }} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <FComponentsLib.FContentText
                      text={rl.type.join('/')}
                      type={'additional2'}
                    />
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={'|'}
                      style={{ color: '#666' }}
                    />
                    <FComponentsLib.FContentText
                      type={'additional2'}
                      text={`最近更新${rl.updateDate}`}
                      style={{ color: '#666' }}
                    />
                  </div>
                </div>
              </div>
            </div>);
          })
      }
    </div>
  </FDrawer>);
}
